import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "72",
  height: "72",
  viewBox: "0 0 72 72",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("title", null, "icon-ui-nav-wishlists", -1),
    _createElementVNode("path", {
      d: "M40.5 54H54V40.5H40.5V54zm0-22.5H54V18H40.5v13.5zM18 54h13.5V40.5H18V54zm0-22.5h13.5V18H18v13.5zM9 63h54V9H9v54zm58.5 9h-63C2.01 72 0 69.99 0 67.5v-63C0 2.01 2.01 0 4.5 0h63C69.99 0 72 2.01 72 4.5v63c0 2.49-2.01 4.5-4.5 4.5z",
      "fill-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }